<template>
  <div class="container">
    <div class="topbanInfo">
      <div class="tits">{{ $t('home').Awayofexchange }}</div>
      <div class="tips">{{ $t('home').Jointhefastest }}</div>
      <div class="tips">{{ $t('home').ExchangeLowest }}</div>
      <div class="btbn" @click="$router.push({ name: 'Trade' })">{{ $t('home').TradeNow }}</div>
    </div>
    <div class="info">
      <!-- 标题 -->
      <div class="tit">{{ $t('home').Yourinvestmentportfolio }}</div>
      <!-- 产品列表 -->
      <div class="productInfo">
        <!-- 分类 -->
        <!-- 行情分类 -->
        <div class="proTab"><span v-for="(item, index) in tabsMarket" :key="`tabma${index}`" :class="activeMarket == item.value ? 'active' : ''" @click="changeMarketTab(item.value)">{{ item.name
            }}</span></div>
        <!-- 产品标题 -->
        <div class="title">
          <div class="name">{{ $t('market').product }}</div><span>{{ $t('market').Latestprice }}</span><span>{{
            $t('market').volume }}</span><span>{{ $t('market').ChangeRatio }}</span><span>{{ $t('market').operate
            }}</span>
        </div>
        <!-- 添加自选 -->
        <div class="addSelectBtn" v-if="activeMarket == 0 && showAddSelect">
          <van-button block @click="$router.push({ name: 'MySelect', query: { i: true } })">{{ $t('market').Addoptional
          }}</van-button>
        </div>
        <!-- 产品列表 -->
        <div class="item" v-for="(item, index) in pList" :key="`pro${index}`" @click="$router.push({ name: 'Trade', query: { id: item.productId } })">
          <div class="name"> <img :src="baseUrl + item.logoUrl" />{{ item.name }} </div>
          <span :class="item.priceChangeRatio > 0 ? 'green' : 'red'">{{ item.newPrice }}</span>
          <span>{{ item.volume | formatNumber }}</span>
          <span :class="item.priceChangeRatio > 0 ? 'green' : 'red'">{{ item.priceChangeRatio
          }}%</span>
          <span class="btn">{{ $t('tabBar').trade }}</span>
        </div>
        <div class="bombtn" @click="$router.push({ name: 'Market' })">{{ $t('property').Seemore }}</div>
      </div>
      <!-- 考虑一个由技术开发 -->
      <div class="tit">{{ $t('home').Considera }}<br><span>{{ $t('home').technologydevelopment }}</span></div>
      <div class="technologyInfo">
        <div class="item">
          <div class="tt">
            <img src="@/assets/img/home_t_i.png" class="timg" />
            <span>{{ $t('home').Announcesponsorship }}</span>
          </div>
          <div class="txt">{{ $t('home').AnnouncesponsorshipTips }}</div>
        </div>
        <div class="item">
          <div class="tt">
            <img src="@/assets/img/home_t_i.png" class="timg" />
            <span>{{ $t('home').Disregardingcryptocurrency }}</span>
          </div>
          <div class="txt">{{ $t('home').DisregardingcryptocurrencyTips }}</div>
        </div>
        <div class="item">
          <div class="tt">
            <img src="@/assets/img/home_t_i.png" class="timg" />
            <span>{{ $t('home').Recordovergrowth }}</span>
          </div>
          <div class="txt">{{ $t('home').RecordovergrowthTips }}</div>
        </div>

      </div>
      <!-- 专业安全以确保安全 您的资金 -->
      <div class="tit">{{ $t('home').Professionalsafety }} <span>{{ $t('home').Yourfunds }}</span></div>
      <div class="assetInfo">
        <div class="item">
          <div class="tt">
            <img src="@/assets/img/home_s_i1.png" class="timg" />
            <span>{{ $t('home').innovativeproduct }}</span>
          </div>
          <div class="txt">1.{{ $t('home').innovativeproduct1 }}
            <br>2.{{ $t('home').innovativeproduct2 }}
            <br> 3.{{ $t('home').innovativeproduct3 }}
          </div>
        </div>
        <div class="item">
          <div class="tt">
            <img src="@/assets/img/home_s_i2.png" class="timg" />
            <span>{{ $t('home').Industrysecurity }}
            </span>
          </div>
          <div class="txt">1.{{ $t('home').Industrysecurity1 }}
            <br>2.{{ $t('home').Industrysecurity2 }}
            <br>3.{{ $t('home').Industrysecurity3 }}
          </div>
        </div>
        <div class="item">
          <div class="tt">
            <img src="@/assets/img/home_s_i3.png" class="timg" />
            <span>{{ $t('home').Excellentservice }}</span>
          </div>
          <div class="txt">1.{{ $t('home').Excellentservice1 }}
            <br>2.{{ $t('home').Excellentservice2 }}
            <br>3.{{ $t('home').Excellentservice3 }}
          </div>
        </div>
        <div class="item">
          <div class="tt">
            <img src="@/assets/img/home_s_i4.png" class="timg" />
            <span>{{ $t('home').Derivativeexchange }}</span>
          </div>
          <div class="txt">1.{{ $t('home').Derivativeexchange1 }}
            <br>2.{{ $t('home').Derivativeexchange2 }}
            <br>3.{{ $t('home').Derivativeexchange3 }}
          </div>
        </div>
      </div>
      <!-- 更好地整合到WEB3.0 -->
      <div class="tit">{{ $t('home').Betterintegrationinto }}<br><span>WEB3.0</span></div>
      <!-- 下载 -->
      <div class="downInfo">
        <div class="imginfo">
          <div class="left">
            <div class="codess">
              <div class="code">
                <div class="imgs"><qrcode-vue :value="qrcodeUrl" :size="130" level="H" class="qrimg"></qrcode-vue></div>
                <div class="lab">
                  <div class="t1">{{ $t('home').Scandownload }}</div>
                  <div class="t2">IOS & Android</div>
                </div>
              </div>
            </div>
            <div class="lables">
              <div class="item" @click="openTo(iosUrl)">
                <svg-icon class-name="svgs" icon-class="apple" />
                <div class="txt">App Store</div>
              </div>
              <div class="item" @click="openTo(androidUrl)">
                <svg-icon class-name="svgs" icon-class="googlepay" />
                <div class="txt">Google Pay</div>
              </div>
            </div>
          </div>
          <div class="txts">
            <div class="tt1">{{ $t('home').Conducttransactions }}</div>
            <div class="tt2">{{ $t('home').ConducttransactionsTips }}</div>
          </div>
          <img src="@/assets/img/home-download-bg.gif" class="gifimg" />
        </div>
      </div>
    </div>
    <!-- 取款选择 -->
    <van-popup v-model="showWithSelect" position="center" style="width: 400px;" closeable>
      <div class="withSelInfo">
        <div class="tit">{{ $t('common').Withdraw }}</div>
        <div class="tabs" @click="$router.push({ name: 'WithCurrency' })">{{ $t('common').Cryptocurrencywithdrawal }}
          <span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span>
        </div>
        <div class="tabs" @click="$router.push({ name: 'With' })">{{ $t('common').Fiatmoneywithdrawal }}<span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import productApi from '@/api/product'
import systemApi from '@/api/system'
import { webSocket } from "@/mixins/webSocket.js";
import QrcodeVue from 'qrcode.vue'
import { Token } from '@/utils/mm'
export default {
  name: 'Home',
  mixins: [webSocket],
  components: {
    QrcodeVue
  },
  data() {
    return {
      showRegister: true,
      //行情分类
      activeMarket: 1,
      showWithSelect: false,
      baseUrl: window.baseURL,
      showAddChat: false,
      pList: [],
      showAddSelect: false,
      qrcodeUrl: '',
      iosUrl: '',
      androidUrl: '',
    }
  },
  computed: {
    tabsMarket() {
      return [{
        name: this.$t('home').optional,
        value: 0
      }, {
        name: this.$t('home').HotList,
        value: 1
      }]
    },
  },
  watch: {},
  mounted() {
    window.scrollTo(0, 0);
    if (Token.get()) this.showRegister = false
    this.getConfig()
    this.getHomeHotList()
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
  },
  methods: {
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      this.qrcodeUrl = res.systemSetting.qrcodeUrl
      this.iosUrl = res.systemSetting.iosUrl
      this.androidUrl = res.systemSetting.androidUrl
    },
    //跳转新窗口
    openTo(val) {
      window.open(val)
    },
    //跳转交易
    toTrade(val) {
      if (this.$route.name == 'Trade') return
      if (val)
        this.$router.push({ name: 'Trade', query: { type: val } })
      else
        this.$router.push({ name: 'Trade' })
    },
    //切换行情分类
    changeMarketTab(val) {
      this.activeMarket = val
      if (val == 0) this.getOptionalProductList()
      if (val == 1) this.getHomeHotList()
    },
    onBannerGo(val) {
      if (val.type == 1)
        this.$router.push({ path: val.path })
      else
        location.href = val.path
    },
    // 查询自选产品列表
    async getOptionalProductList() {
      if (!Token.get()) {
        this.pList = []
        return
      }
      var parms = {}
      parms.pageNum = 1
      parms.pageSize = 1000
      parms.productBusiness = '1'
      const res = await productApi.getOptionalProductList(parms)
      this.pList = res.rows;
      if (this.pList.length > 0)
        this.showAddSelect = false
      else this.showAddSelect = true
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    // 首页产品列表
    async getHomeHotList() {
      const res = await productApi.getHomeHotList()
      this.pList = res.rows;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //推送
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: that.pList.map(item => item.symbol)
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 产品列表
        that.pList.forEach((sItem) => {
          let quotes = reslult.find(item => item.Symbol == sItem.symbol);
          if (quotes) {
            sItem.newPrice = quotes.NewPrice
            sItem.volume = quotes.Volume
            sItem.priceChangeRatio = quotes.PriceChangeRatio
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 56px;
  padding-bottom: 100px;
  width: 100%;
  background: var(--background_color);
  .topbanInfo {
    width: 100%;
    height: 100vh;
    background-image: url('../../assets/img/home-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tits {
      font-family: PingFang-SC-Heavy;
      font-size: 76px;
      line-height: 90px;
      margin-bottom: 50px;
      color: #fff;
      margin-top: -70px;
    }
    .tips {
      font-family: PingFang-SC-Heavy;
      font-size: 20px;
      margin-bottom: 20px;
      color: #fff;
    }
    .btbn {
      margin-top: 20px;
      padding: 20px 100px;
      border-radius: 30px;
      background-image: linear-gradient(90deg, #b671e6 0%, #f31183 100%);
      color: #fff;
      font-size: 17px;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .tops {
    background: #000000;

    .bgg {
      padding-top: 30px;
      margin: 0 auto;
      max-width: 1480px;
      background: #020202;
      // background-image: url(../../assets/img/home-banner-background.png);
      background-position: 100% 0;
      background-repeat: no-repeat;
      background-size: contain;

      .swipeInfo {
        margin: 0 auto;
        max-width: 1280px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          .stit {
            font-size: 60px;
            color: #fff;
            font-weight: 700;
            line-height: 72px;
          }

          .sbtn {
            margin-top: 50px;
            border-radius: 10px;
            background: #fff;
            width: 200px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: #000000;

            &:hover {
              opacity: 0.8;
            }
          }
        }

        .swimg {
          width: 50%;
        }
      }

      .numInfo {
        padding: 50px 0;
        margin: 0 auto;
        max-width: 1062px;
        display: flex;
        justify-content: space-between;

        .item {
          border-radius: 20px;
          border: 1px solid #343434;
          background-color: #0a0a0a;
          text-align: center;
          width: 23%;
          padding: 20px;

          .num {
            font-size: 24px;
            font-weight: 700;
            color: #fff;
          }

          .txt {
            margin-top: 20px;
            font-size: 16px;
            color: #fff;
          }
        }
      }
    }
  }

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .tit {
      margin-top: 150px;
      font-size: 45px;
      color: var(--text_color);
      text-align: center;
      line-height: 60px;

      span {
        color: var(--primary_color);
      }
    }

    .productInfo {
      padding: 60px 0;

      .proTab {
        font-size: 20px;
        color: var(--ntext_color);
        span {
          margin-right: 40px;
        }

        .active {
          color: var(--primary_color);
          padding-bottom: 10px;
          border-bottom: 2px solid var(--primary_color);
        }
      }

      .title {
        margin-top: 30px;
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--ntext_color);
        font-size: 14px;
        height: 50px;
        border-bottom: 1px solid var(--line_color);

        .name {
          width: 30%;
          text-align: left;
        }

        span {
          width: 14%;
          text-align: right;
        }
      }

      .addSelectBtn {
        margin: 20px 150px;

        .van-button {
          margin-top: 50px;
          background: var(--primary_color);
          height: 50px;
          border-radius: 25px;
          border: 0;
          font-size: 16px;
          color: #fff;
        }

        .van-button:hover {
          opacity: 0.8;
        }
      }

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 10px;
        color: var(--text_color);
        font-size: 16px;
        border-bottom: 1px solid var(--line_color);

        .name {
          font-weight: bold;
          width: 30%;
          text-align: left;
          display: flex;
          align-items: center;

          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            margin-right: 20px;
          }
        }

        span {
          width: 14%;
          text-align: right;
        }

        .btn {
          font-size: 14px;
          color: var(--primary_color);
          text-decoration: underline;
        }
      }

      .item:hover {
        background: var(--info_color);
      }

      .bombtn {
        margin-top: 30px;
        text-align: right;
        font-size: 14px;
        color: var(--ntext_color);

        &:hover {
          color: var(--primary_color);
          text-decoration: underline;
        }
      }
    }
    .technologyInfo {
      margin-top: 60px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 23px;
      .item {
        background: var(--info_color);
        padding: 20px 20px 30px 20px;
        border-radius: 5px;
        .tt {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .timg {
            width: 55px;
            height: 55px;
            margin-right: 20px;
          }

          span {
            font-size: 20px;
            line-height: 1.3;
            color: var(--primary_color);
          }
        }

        .txt {
          margin-top: 30px;
          font-size: 16px;
          line-height: 1.7;
          color: var(--ntext_color);
        }
      }
    }
    .assetInfo {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
      margin-top: 60px;
      cursor: pointer;
      .item {
        background: var(--info_color);
        padding: 32px;
        border-radius: 5px;
        .tt {
          display: flex;
          flex-direction: column;

          .timg {
            width: 55px;
            height: 55px;
          }

          span {
            font-size: 24px;
            color: var(--primary_color);
            margin-top: 30px;
          }
        }

        .txt {
          margin-top: 30px;
          line-height: 1.8;
          font-size: 18px;
          color: var(--text_color);
        }
      }
    }
    .downInfo {
      margin-top: 60px;
      .imginfo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--info_color);
        padding: 20px 32px;
        border-radius: 5px;

        .left {
          .codess {
            display: flex;

            .code {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-right: 50px;

              .imgs {
                width: 170px;
                height: 170px;
                // padding: 10px;
                border-radius: 8px;
                background: var(--info_color);

                .qrimg {
                  width: 150px;
                  height: 150px;
                  padding: 10px;
                  background: #fff;
                  border-radius: 8px;
                }
              }

              .lab {
                margin-left: 10px;

                .t1 {
                  font-size: 16px;
                  color: var(--ntext_color);
                }

                .t2 {
                  margin-top: 10px;
                  font-size: 21px;
                  color: var(--text_color);
                  font-weight: bold;
                }
              }
            }
          }

          .lables {
            margin-top: 10px;
            display: flex;

            .item {
              margin-right: 30px;
              background: var(--text_color);
              border-radius: 5px;
              padding: 5px 10px;
              display: flex;
              align-items: center;

              .svgs {
                width: 25px;
                height: 25px;
                color: var(--background_color);
              }

              .txt {
                margin-left: 20px;
                font-size: 14px;
                color: var(--background_color);
              }
            }

            .item:hover {
              opacity: 0.8;
            }
          }
        }
        .txts {
          width: 550px;

          .tt1 {
            font-size: 24px;
            color: var(--text_color);
            font-weight: bold;
          }

          .tt2 {
            margin-top: 20px;
            font-size: 18px;
            line-height: 1.8;
            color: var(--ntext_color);
          }
        }

        .gifimg {
          width: 250px;
          height: 250px;
        }
      }
    }
  }

  .startInfo {
    padding-top: 150px;
    text-align: center;
    background: linear-gradient(
      180deg,
      var(--color-linearStart) 0,
      var(--background_color) 100%
    );

    .title {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tips {
      margin-top: 20px;
      font-size: 20px;
      color: var(--ntext_color);
    }

    .txtss {
      margin-top: 50px;
      display: flex;

      span {
        width: 33%;
        font-size: 20px;
        color: var(--text_color);
        font-weight: bold;
        border-right: 2px solid var(--text_color);
      }
    }

    .btns {
      margin-top: 50px;
      display: flex;
      justify-content: center;

      .btn {
        font-size: 16px;
        color: var(--background_color);
        background: var(--text_color);
        width: 160px;
        height: 50px;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn:hover {
        opacity: 0.8;
      }
    }
  }

  .withSelInfo {
    padding: 20px;

    .tit {
      margin-bottom: 30px;
      text-align: center;
      font-size: 21px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tabs {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
      background: var(--info_color);
      border-radius: 10px;
      padding: 20px;
    }

    .tabs:hover {
      opacity: 0.8;
    }
  }
}

::v-deep .van-search__content {
  background-color: var(--info_color);
}

::v-deep .van-cell {
  color: var(--text_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}
</style>
